import { render, staticRenderFns } from "./whatsapp-component.vue?vue&type=template&id=344de5a9&lang=html"
import script from "./whatsapp-component.vue?vue&type=script&lang=js"
export * from "./whatsapp-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports